import {
  FAILURE_FETCH_GAMBLER_INFO,
  FETCH_GAMBLER_INFO,
  SUCCESS_FETCH_GAMBLER_INFO,
} from '../../actions/creators/GamblerInfo'

const initialState = {
  fetching: false,
  data: null,
  error: null,
}

export default function gamblerInfoReducer(state, action) {
  if (state === undefined) {
    return initialState;
  }

  switch (action.type) {
    case FETCH_GAMBLER_INFO: {
      return {
        ...state,
        fetching: true,
        data: null,
        error: null,
      }
    }
    case SUCCESS_FETCH_GAMBLER_INFO: {
      return {
        ...state,
        fetching: false,
        error: null,
        data: action.data,
      }
    }
    case FAILURE_FETCH_GAMBLER_INFO: {
      return {
        ...state,
        fetching: false,
        data: null,
        error: action.data,
      }
    }
  }
  return state;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/GamblerInfoReducer.js